import {
  IPatient,
  RomexisBridgeConfiguration,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { IBaseCommand, IBridgeIntegration } from '../../send-command-to-device';

export const ROMEXIS_INTEGRATION: IBridgeIntegration = {
  label: 'Romexis',
  description:
    'One-way integration for opening patient files within Planmeca Romexis',
};

export type RomexisOpenPatientCommand = IBaseCommand<
  RomexisToDeviceCommand.OpenRomexis,
  {
    patient: WithRef<IPatient>;
    mode: RomexisCaptureMode | RomexisLegacyCaptureMode;
    config: RomexisBridgeConfiguration;
  }
>;

export enum RomexisLegacyCaptureMode {
  None,
  Panoramic,
  Cephalometric,
  Intraoral,
  Intracam,
  Twain,
  CrScanner,
  CBCT3D,
}

export enum RomexisCaptureMode {
  None = -1,
  Panoramic = 0,
  Cephalometric = 1,
  Intraoral = 2,
  Intracam = 3,
  Twain = 4,
  CrScanner = 5,
  CBCT3D = 7,
}

export const ROMEXIS_LEGACY_MODE_MAP: Record<
  RomexisCaptureMode,
  RomexisLegacyCaptureMode
> = {
  [RomexisCaptureMode.None]: RomexisLegacyCaptureMode.None,
  [RomexisCaptureMode.Panoramic]: RomexisLegacyCaptureMode.Panoramic,
  [RomexisCaptureMode.Cephalometric]: RomexisLegacyCaptureMode.Cephalometric,
  [RomexisCaptureMode.Intraoral]: RomexisLegacyCaptureMode.Intraoral,
  [RomexisCaptureMode.Intracam]: RomexisLegacyCaptureMode.Intracam,
  [RomexisCaptureMode.Twain]: RomexisLegacyCaptureMode.Twain,
  [RomexisCaptureMode.CrScanner]: RomexisLegacyCaptureMode.CrScanner,
  [RomexisCaptureMode.CBCT3D]: RomexisLegacyCaptureMode.CBCT3D,
};

export const ROMEXIS_CAPTURE_MODES = [
  {
    mode: RomexisCaptureMode.None,
    label: 'Open Patient',
  },
  {
    mode: RomexisCaptureMode.Panoramic,
    label: 'Panoramic',
  },
  {
    mode: RomexisCaptureMode.Cephalometric,
    label: 'Cephalometric',
  },
  {
    mode: RomexisCaptureMode.Intraoral,
    label: 'Intraoral',
  },
  {
    mode: RomexisCaptureMode.Intracam,
    label: 'Intracam',
  },
  {
    mode: RomexisCaptureMode.Twain,
    label: 'TWAIN',
  },
  {
    mode: RomexisCaptureMode.CrScanner,
    label: 'CR Scanner',
  },
  {
    mode: RomexisCaptureMode.CBCT3D,
    label: 'CBCT 3D',
  },
];

export enum RomexisToDeviceCommand {
  OpenRomexis = 'romexis.openRomexis',
}
